<template>
  <section>
    <div>
      <SectionHeading>A practical path to production-ready serverless</SectionHeading>
      <SectionSubheading>
        Learn what works and what doesn't in real-world AWS serverless systems.
      </SectionSubheading>
    </div>

    <div class="text-base sm:text-xl">
      <p>Recommended Learning Schedule based on <strong>10-15 hours/week</strong></p>
      <p><strong>Self-Paced</strong> online bootcamp, you can take as much time as you need.
      </p>
    </div>

    <div>
      <div class="grid grid-cols-3 gap-x-4 text-lg font-extralight">
        <!-- sad man + down arrow -->
        <div class="flex flex-col col-span-1 self-end">
          <img class="w-48 self-center"
            loading="lazy"
            src="https://res.cloudinary.com/prsls/image/upload/f_auto,c_scale,w_192/website/prsls-sad_man.png">

          <img class="w-16 self-center"
            loading="lazy"
            src="https://res.cloudinary.com/prsls/image/upload/f_auto,c_scale,w_64/website/down-arrow.png">

        </div>

        <!-- 3 confusions -->
        <div class="col-span-2 flex flex-col gap-y-4 text-sm sm:text-lg">
          <div class="flex flex-row">
            <img class="w-10 sm:w-16 h-10 sm:h-16 mr-1 sm:mr-5"
              loading="lazy"
              src="https://res.cloudinary.com/prsls/image/upload/f_auto,c_scale,w_64,h_64/website/prsls-sad_face.png">
            <p class="place-self-center">
              Your team has serverless workloads in production, but testing, observability, and failure
              handling still feel weaker than they should.
            </p>
          </div>

          <div class="flex flex-row">
            <img class="w-10 sm:w-16 h-10 sm:h-16 mr-1 sm:mr-5"
              loading="lazy"
              src="https://res.cloudinary.com/prsls/image/upload/f_auto,c_scale,w_64,h_64/website/prsls-sad_face.png">
            <p class="place-self-center">
              You are unsure when to choose Lambda, Step Functions, EventBridge, SNS, SQS, Kinesis,
              API Gateway, or DynamoDB Streams, and what trade-offs to consider.
            </p>
          </div>

          <div class="hidden sm:flex flex-row">
            <img class="w-10 sm:w-16 h-10 sm:h-16 mr-1 sm:mr-5"
              loading="lazy"
              src="https://res.cloudinary.com/prsls/image/upload/f_auto,c_scale,w_64,h_64/website/prsls-sad_face.png">
            <p class="place-self-center">
              You want to move faster with AWS and AI tools without introducing hidden production problems.
            </p>
          </div>
        </div>
      </div>

      <!-- 4 week schedule -->
      <div class="my-1">
        <FourWeekProgram />
      </div>

      <div class="grid grid-cols-3 text-base sm:text-xl font-thin">
        <span class="col-span-2"></span>
        <img class="w-16 justify-self-center"
            loading="lazy"
            src="https://res.cloudinary.com/prsls/image/upload/f_auto,c_scale,w_64/website/down-arrow.png">

        <p class="col-span-2 text-right text-sm sm:text-xl w-48 sm:w-96 justify-self-end place-self-center">
          Leave with practical patterns you can apply to real AWS workloads, and the judgment to make
          <span class="font-semibold">safer architecture decisions</span>.
        </p>
        <img class="w-48 justify-self-center"
          loading="lazy"
          src="https://res.cloudinary.com/prsls/image/upload/f_auto,c_scale,w_192/website/prsls-hero.png">
      </div>
    </div>
  </section>
</template>

<script>
import FourWeekProgram from '@/components/schedule-section/FourWeekProgram.vue'

export default {
  components: {
    FourWeekProgram
  }
}
</script>
